import React, { Component } from "react";
/* import PropTypes from 'prop-types';*/
import { getEmptyImage } from "react-dnd-html5-backend";
import { DragSource } from "react-dnd";
import TextMaskResizeHandler from "views/components/Editor/textMaskResizeHandler/TextMaskResizeHandlerContainer";
import { Image } from "views/components";
import ResizeBox from "views/components/Editor/ResizeBox";
import InnerImageRotateHandle from "views/components/Editor/rotateHandler/InnerImageRotateHandle";
import { rotatePoint } from "lib/geometry/rotation";

const TextMaskingDraggableImageSource = {
  beginDrag(props, monitor, component) {
    props.startCropMoving();

    return {};
  },
  endDrag(props, monitor) {
    const differenceFromInitialOffset =
      monitor.getDifferenceFromInitialOffset();

    const rotatedOffset = rotatePoint(
      differenceFromInitialOffset.x,
      differenceFromInitialOffset.y,
      0,
      0,
      -props.textElement.angle
    );

    props.finishCropMoving({
      differenceFromInitialOffset: {
        ...differenceFromInitialOffset,
        ...rotatedOffset
      }
    });
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}

export class TextMaskingDraggableImage extends Component {
  constructor(props) {
    super(props);
    // Zero-size marker positioned at the image centre inside the rotating
    // wrap. The rotating wrap's transform-origin is also the image centre,
    // so this marker's screen position is invariant under the wrap's
    // rotation — exactly what InnerImageRotateHandle needs as a pivot.
    this.rotatePivotRef = React.createRef();
  }

  componentDidMount() {
    const { connectDragPreview } = this.props;
    if (connectDragPreview) {
      connectDragPreview(getEmptyImage(), {
        captureDraggingState: true
      });
    }
  }

  cancelClick(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  render() {
    const {
      connectDragSource,
      textElement,
      isCropping,
      zoom,
      onInnerImageRotationPreview,
      onInnerImageRotationCommit
    } = this.props;

    const maskImage = textElement.maskImage;
    const rotationDeg = maskImage.rotation || 0;

    const imageLeft = maskImage.left * zoom;
    const imageTop = maskImage.top * zoom;
    const imageWidth = maskImage.width * zoom;
    const imageHeight = maskImage.height * zoom;

    const restrictions = textElement.restrictions || [];
    const isInnerImageRotateRestricted = restrictions.includes("angle");

    return connectDragSource(
      <div
        onClick={this.cancelClick}
        style={{
          position: "absolute",
          transform: [`rotate(${textElement.angle}deg)`].join(" "),
          top: textElement.top * zoom,
          left: textElement.left * zoom,
          height: `${textElement.height * zoom}px`,
          width: `${textElement.width * zoom}px`
        }}
      >
        <div
          style={{
            position: "absolute",
            top: imageTop,
            left: imageLeft,
            width: imageWidth,
            height: imageHeight,
            transform: `rotate(${rotationDeg}deg)`,
            transformOrigin: "center",
            zIndex: 4,
            opacity: isCropping ? 0 : 1
          }}
        >
          <Image
            src={maskImage.previewSrc || maskImage.src}
            height={imageHeight}
            width={imageWidth}
            filter="brightness(0.5)"
          />
          <ResizeBox
            Handler={TextMaskResizeHandler}
            isResizing={false}
            isCropping={true}
          />
        </div>
        {onInnerImageRotationPreview &&
          onInnerImageRotationCommit &&
          !isInnerImageRotateRestricted && (
            <div
              style={{
                position: "absolute",
                top: imageTop,
                left: imageLeft,
                width: imageWidth,
                height: imageHeight,
                transform: `rotate(${rotationDeg}deg)`,
                transformOrigin: "center",
                zIndex: 20,
                pointerEvents: "none"
              }}
            >
              <div
                ref={this.rotatePivotRef}
                style={{
                  position: "absolute",
                  left: `${imageWidth / 2}px`,
                  top: `${imageHeight / 2}px`,
                  width: 0,
                  height: 0
                }}
              />
              <InnerImageRotateHandle
                anchorLeft={imageWidth / 2}
                anchorTop={imageHeight}
                counterRotateDeg={rotationDeg}
                pivotRef={this.rotatePivotRef}
                rotation={rotationDeg}
                onRotationPreview={onInnerImageRotationPreview}
                onRotationCommit={onInnerImageRotationCommit}
              />
            </div>
          )}
      </div>
    );
  }
}

/* TextMaskingDraggableImage.propTypes = propTypes;*/

// Export the wrapped component:
export default DragSource(
  "TEXT_MASK_IMAGE",
  TextMaskingDraggableImageSource,
  collect
)(TextMaskingDraggableImage);
